import React from "react";
import "./Home.css";
import Topbar from "../../Components/Topbar/Topbar";
import Navbar from "../../Components/Navbar/Navbar";
import Header from "./Components/Header/Header";
import About from "./Components/About/About";
import Assistance from "./Components/Assistance/Assistance";
import Fatca from "./Components/Fatca/Fatca";
import Services from "./Components/Services/Services";
import Desk from "./Components/Desk/Desk";
import GetInTouch from "./Components/GetInTouch/GetInTouch";
import Footer from "../../Components/Footer/Footer";
import Blog from "./Components/Blog/Blog";
const Home = () => {
  return (
    <div className="home__screen">
      <Topbar />
      <Navbar />
      <Header />
      <About />
      <Assistance />
      <Fatca />
      <Services />
      <Desk />
      <Blog />
      <GetInTouch />
      <Footer />
    </div>
  );
};

export default Home;
